module.exports = __webpack_public_path__ + "assets/img/Import.08e638dd.jpg";